import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DisdetailPage } from './disdetail.page';

const routes: Routes = [
  {
    path: '',
    component: DisdetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DisdetailPageRoutingModule {}
